import styled from "styled-components";
import { useDesignThumbnailURL } from "../../hooks/libraries/designs/useDesignThumbnailURL";
import { EfsMelcoModelsDesign } from "melco-shared-logic";

const PreviewWrapper = styled.div`
  max-height: 400px;
  display: flex;
  justify-content: center;
`;

const StyledPreviewImage = styled.img`
  max-height: 400px;
`;

export type PreviewedDesignProps = {
  design: EfsMelcoModelsDesign;
};

export const PreviewedDesign: React.FC<PreviewedDesignProps> = ({ design }) => {
  const imageSrc = useDesignThumbnailURL(design, 1000, 1000);

  return (
    <PreviewWrapper>
      {imageSrc && (
        <StyledPreviewImage src={imageSrc} alt={design.name ?? ""} />
      )}
    </PreviewWrapper>
  );
};
